import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import {} from 'react-router-dom';
import {
  ChakraProvider,
  Flex,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import { useState, Suspense, lazy } from 'react';
import { PublicRoute } from 'PublicRoute';
// Chakra imports
import { Spinner } from '@chakra-ui/react';
import { PrivateRoute } from 'PrivateRoute';

const AuthLayout = lazy(() => import('./layouts/auth'));
const AdminLayout = lazy(() => import('./layouts/admin'));

const LoadingFallback = () => (
  <Flex w={'100%'} h={'100vh'} justifyContent={'center'} alignItems={'center'}>
    <Spinner
      thickness="4px"
      speed="0.65s"
      emptyColor="gray.200"
      color="blue.500"
      size="xl"
    />
  </Flex>
);

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route
          path="auth/*"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            </Suspense>
          }
        />
        <Route
          path="admin/*"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <PrivateRoute>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route path="/" element={<Navigate to="/admin/stake-info" replace />} />
        <Route
          index
          path="/admin"
          element={<Navigate to="/admin/stake-info" replace />}
        />
      </Routes>
    </ChakraProvider>
  );
}
